import { ReactComponent as LoadingAnimation } from 'assets/icons/loading.svg'

const LoadingSpinner = (): JSX.Element => {
  // The className is used in Cypress tests, to wait for loading to finish.
  return <LoadingAnimation role="img" className="LoadingAnimation" />
}

export default LoadingSpinner
